export default {
  app: {
    name: "Sportsbook",
    full: "Back Office Template",
    minimized: "BO"
  },
  no_records: "No records",
  welcome: "Welcome back, {user}!",
  login: "Sign In to your account",
  login_success: "Login successfully",
  relogin: "Please re-login to your account again.",
  expired: "You have been signed out due to multiple logins!",
  denied: "Permission Denied!",
  success: "You have successfully completed!",
  select_date_range: "Please select date",
  permission_denied: "You are not authorised to perform this action!",
  search_by_id_name: "Search by ID or Name",
  search_by_name: "Search by Name",
  close: "Account closed. Please contact your addministrator.",
  suspend: "Account suspended. Please contact your addministrator.",
  suspend_alert1: "Your account has been changed to \"View Only\".",
  suspend_alert2: "Kindly refer to your Upline.",
  freeze: "Account freezed. Please contact your addministrator.",
  account_id_length_error: "Invalid account id length",
  change_user_status_confirm: "Are you sure you want to change the Account Status?",
  delete_confirm: "Are you sure you want to delete \"{name}\"?",
  update_account_status_confirm: "Are you sure want to update account status?",
  update_account_status_cancel: "Update account status failed.",
  update_account_status_success: "Account status successfully updated!",
  update_account_password_confirm: "Are you sure want to update account password?",
  update_account_password_cancel: "Update account password failed.",
  update_account_password_success: "Password successfully updated!",
  update_account_security_confirm: "Are you sure want to update account security?",
  update_account_security_cancel: "Update account security failed.",
  update_account_security_success: "Account security successfully updated!",
  update_account_authority_confirm: "Are you sure want to update account authority?",
  update_account_authority_cancel: "Update account authority failed.",
  update_account_authority_success: "Account authority successfully updated!",
  block_sub_account_confirm: "Are you sure want to block sub account?",
  block_sub_account_cancel: "Block sub account failed.",
  block_sub_account_success: "Sub account successfully blocked!",
  unblock_sub_account_confirm: "Are you sure want to unblock sub account?",
  unblock_sub_account_cancel: "Unblock sub account failed.",
  unblock_sub_account_success: "Sub account successfully unblocked!",
  successful_update_profile: "You have successfully update profile.",
  successful_update_security: "You have successfully update security code.",
  successful_create_account: "You have successfully created new account. ",
  update_platform_settings_confirm: "Are you sure want to update platform settings?",
  update_platform_settings_cancel: "Update platform settings failed.",
  update_platform_settings_success: "Platform settings successfully updated!",
  reset_accumulate_win_confirm: "Are you sure want to reset accumualte win limit?",
  reset_accumulate_win_cancel: "Reset accumulate win limit failed.",
  reset_accumulate_win_success: "Accumulate win limit successfully reset!",
  parent_platform_disabled: "Upline platform settings has been disabled.",
  copy_success: "The account information has been copied to clipboard.",
  copy_failed: "Your browser doesn't support copied to clipboard.",
  copy_all_upline: "Copy soccer HDP upline to all sport types",
  copy_all_account: "Copy soccer HDP account to all sport types",
  copy_all_remaining: "Copy soccer HDP remaining to all sport types",
  copy_all_min: "Copy soccer HDP min to all sport types",
  copy_all_min_bet: "Copy soccer min bet to all sport types",
  copy_all_max_bet: "Copy soccer max bet to all sport types",
  copy_all_max_per_match: "Copy soccer max per match to all sport types",
  create_secondary_account_success: "Secondary account successfully created! Please relogin again.",
  first_sub_account_success: "Sub account successfully updated! Please relogin again.",
  update_account_commission_confirm: "Are you sure want to update account commission?",
  update_account_commission_cancel: "Update account commission failed.",
  update_account_commission_success: "Account commission successfully updated!",
  update_account_position_confirm: "Are you sure want to update account position taking?",
  update_account_position_cancel: "Update account position taking failed.",
  update_account_position_success: "Account position taking successfully updated!",
  update_account_bet_limit_confirm: "Are you sure want to update account bet limit?",
  update_account_bet_limit_cancel: "Update account bet limit failed.",
  update_account_bet_limit_success: "Account bet limit successfully updated!",
  update_account_profile_confirm: "Are you sure want to update account profile?",
  update_account_profile_cancel: "Update account profile failed.",
  update_account_profile_success: "Account profile successfully updated!",
  create_new_account_confirm: "Are you sure want to create new account?",
  create_new_account_cancel: "Create new account failed",
  create_new_account_success: "New account successfully created!",
  create_sub_account_confirm: "Are you sure want to create sub account?",
  create_sub_account_cancel: "Create sub account failed",
  create_sub_account_success: "Sub account successfully created!",
  update_sub_account_confirm: "Are you sure want to update sub account?",
  update_sub_account_cancel: "Update sub account failed",
  update_sub_account_success: "Sub account successfully updated!",
  unblock_account_profile_confirm: "Are you sure want to unblock account profile?",
  unblock_account_profile_cancel: "Unblock account profile failed.",
  unblock_account_profile_success: "Account profile successfully unblocked!",
  settlement_confirm: "Are you sure want to proceed settlement?",
  settlement_cancel: "Settlement failed",
  settlement_success: "Settlement successfully processed!",
  settlement_not_allowed: "Settlement is not allowed today!",
  search_with_working_date: "Search with working date",
  system_error: "System unable to process your request.",
  invalid_password: "Invalid Username or Password.",
  invalid_account: "Invalid account.",
  block: "Your account has been blocked.",
  invalid_security_code: "Invalid security code.",
  source_account_id_required: "Account ID is required.",
  target_account_id_required: "Target account ID is required.",
  account_id_required: "Account ID is required.",
  sub_login_id_required: "Login ID is required.",
  account_not_exists: "Invalid account.",
  profile_not_exists: "Invalid account.",
  account_inactive: "Inactive account.",
  not_blocked_account: "Valid account.",
  password_required: "Password is required.",
  parent_id_required: "Parent ID is required.",
  parent_not_exists:"Invalid account.",
  invalid_account_type: "Invalid account type.",
  account_exists: "Account is already exists.",
  login_id_required: "Login ID is required.",
  new_login_id_required: "New login ID is required.",
  login_id_not_exists: "Invalid login ID.",
  invalid_authority_role: "Invalid role.",
  profile_inactive: "Invalid profile.",
  secondary_account_exists: "Secondary account is already exists.",
  new_login_id_exists: "New login ID is already exists.",
  new_password_required: "New password is required.",
  security_tag_required: "Security tag is required.",
  security_code_required: "Security code is required.",
  start_date_required: "Start date is required.",
  end_date_required: "End date is required.",
  start_date_gt_end_date: "Start date is greater than end date.",
  start_date_greater_end_date: "Start date is greater than end date.",
  member_id_required: "Member ID is required.",
  currency_code_required: "Currency code is required.",
  commission_setting_not_exists: "Commission setting does not exists.",
  incomplete_account_line: "Incomplete account line.",
  invalid_hdp_package: "Invalid HDP packages.",
  search_id_required: "Search ID is required.",
  profile_id_required: "Profile ID is required.",
  login_not_exists: "Invalid login ID.",
  no_changes: "There is no changes detected.",
  start_date_require: "Start date is required.",
  league_id_required: "League ID is required.",
  sport_type_required: "Sport Type is reuired.",
  match_id_required: "Match ID is required.",
  target_login_id_required: "Target login ID is required.",
  parent_account_not_exists: "Invalid account.",
  parent_account_inactive: "Inactive parent account.",
  parent_profile_not_exists: "Invalid account..",
  parent_profile_inactive: "Inactive parent profile.",
  target_login_id_not_exists: "Invalid account.",
  incorrect_parent: "Invalid parent ID.",
  invalid_session: "Invalid session request.",
  session_expired: "Session expired.",
  settle_amount_required: "Settle amount is required.",
  invalid_settle_amount: "Invalid settle amount.",
  settle_amount_gt_yesterday_balance: "Settle amount is greater than yesterday balance.",
  invalid_account_status: "Invalid account status.",
  bet_limit_packages_required: "Bet limit packages are required.",
  bet_limit_exists: "Bet limit is already exists.",
  member_bet_limit_package_gt_one: "Member bet limit packages is more than one.",
  parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  account_commission_required: "Account commission is required.",
  commission_setting_exists: "Commission setting already exists.",
  parent_comm_not_exists: "Parent commission setting does not exits.",
  exceeded_parent_comm: "Exceeded parent commission setting.",
  others_commission_required: "Others commission setting is required.",
  exceeded_parent_1x2: "Exceeded parent 1x2 commission setting.",
  exceeded_parent_other: "Exceeded parent other commission setting.",
  hdp_commission_required: "HDP commission setting is required.",
  exceeded_parent_hdp_a: "Exceeded parent HPD(A) commission setting.",
  exceeded_parent_hdp_b: "Exceeded parent HPD(B) commission setting.",
  exceeded_parent_hdp_c: "Exceeded parent HPD(C) commission setting.",
  exceeded_parent_hdp_d: "Exceeded parent HPD(D) commission setting.",
  exceeded_parent_hdp_e: "Exceeded parent HPD(E) commission setting.",
  exceeded_parent_hdp_f: "Exceeded parent HPD(F) commission setting.",
  exceeded_parent_hdp_g: "Exceeded parent HPD(G) commission setting.",
  exceeded_parent_hdp_h: "Exceeded parent HPD(H) commission setting.",
  exceeded_parent_hdp_i: "Exceeded parent HPD(I) commission setting.",
  exceeded_parent_hdp_j: "Exceeded parent HPD(J) commission setting.",
  livecasino_upline_pt_required: "[Livecasino] Upline PT setting is required.",
  livecasino_pt_setting_exists: "[Livecasino] PT setting is required.",
  livecasino_parent_pt_not_exists: "[Livecasino] Parent PT setting does not exists.",
  livecasino_parent_min_not_meet: "[Livecasino] Does not match with parent minimum PT.",
  livecasino_exceeded_parent_pt: "[Livecasino] Exceeded parent PT setting.",
  livecasino_account_pt_required: "[Livecasino] Account PT setting is required.",
  livecasino_upline_remaining_required: "[Livecasino] Upline remaining PT setting is required.",
  livecasino_account_min_required: "[Livecasino] Account minimum PT setting is required.",
  livecasino_upline_remaining_gt_account_pt: "[Livecasino] Upline remaining PT setting is greater than account PT setting.",
  livecasino_account_min_gt_p: "[Livecasino] Account minimum PT setting is greater than parent PT setting.",
  slots_upline_pt_required: "[Slots] Upline PT setting is required.",
  slots_pt_setting_exists: "[Slots] PT setting is required.",
  slots_parent_pt_not_exists: "[Slots] Parent PT setting does not exists.",
  slots_parent_min_not_meet: "[Slots] Does not match with parent minimum PT.",
  slots_exceeded_parent_pt: "[Slots] Exceeded parent PT setting.",
  slots_account_pt_required: "[Slots] Account PT setting is required.",
  slots_upline_remaining_required: "[Slots] Upline remaining PT setting is required.",
  slots_account_min_required: "[Slots] Account minimum PT setting is required.",
  slots_upline_remaining_gt_account_pt: "[Slots] Upline remaining PT setting is greater than account PT setting.",
  slots_account_min_gt_pt: "[Slots] Account minimum PT setting is greater than parent PT setting.",
  lotto_upline_pt_required: "[Lotto] Upline PT setting is required.",
  lotto_pt_setting_exists: "[Lotto] PT setting is required.",
  lotto_parent_pt_not_exists: "[Lotto] Parent PT setting does not exists.",
  lotto_parent_min_not_meet: "[Lotto] Does not match with parent minimum PT.",
  lotto_exceeded_parent_pt: "[Lotto] Exceeded parent PT setting.",
  lotto_account_pt_required: "[Lotto] Account PT setting is required.",
  lotto_upline_remaining_required: "[Lotto] Upline remaining PT setting is required.",
  lotto_account_min_required: "[Lotto] Account minimum PT setting is required.",
  lotto_upline_remaining_gt_account_pt: "[Lotto] Upline remaining PT setting is greater than account PT setting.",
  lotto_account_min_gt_pt: "[Lotto] Account minimum PT setting is greater than parent PT setting.",
  keno_upline_pt_required: "[Keno] Upline PT setting is required.",
  keno_pt_setting_exists: "[Keno] PT setting is required.",
  keno_parent_pt_not_exists: "[Keno] Parent PT setting does not exists.",
  keno_parent_min_not_meet: "[Keno] Does not match with parent minimum PT.",
  keno_exceeded_parent_pt: "[Keno] Exceeded parent PT setting.",
  keno_account_pt_required: "[Keno] Account PT setting is required.",
  keno_upline_remaining_required: "[Keno] Upline remaining PT setting is required.",
  keno_account_min_required: "[Keno] Account minimum PT setting is required.",
  keno_upline_remaining_gt_account_pt: "[Keno] Upline remaining PT setting is greater than account PT setting.",
  keno_account_min_gt_pt: "[Keno] Account minimum PT setting is greater than parent PT setting.",
  cockfight_upline_pt_required: "[Cockfight] Upline PT setting is required.",
  cockfight_pt_setting_exists: "[Cockfight] PT setting is required.",
  cockfight_parent_pt_not_exists: "[Cockfight] Parent PT setting does not exists.",
  cockfight_parent_min_not_meet: "[Cockfight] Does not match with parent minimum PT.",
  cockfight_exceeded_parent_pt: "[Cockfight] Exceeded parent PT setting.",
  cockfight_account_pt_required: "[Cockfight] Account PT setting is required.",
  cockfight_upline_remaining_required: "[Cockfight] Upline remaining PT setting is required.",
  cockfight_account_min_required: "[Cockfight] Account minimum PT setting is required.",
  cockfight_upline_remaining_gt_account_pt: "[Cockfight] Upline remaining PT setting is greater than account PT setting.",
  cockfight_account_min_gt_pt: "[Cockfight] Account minimum PT setting is greater than parent PT setting.",
  lottery_upline_pt_required: "[Lottery] Upline PT setting is required.",
  lottery_pt_setting_exists: "[Lottery] PT setting is required.",
  lottery_parent_pt_not_exists: "[Lottery] Parent PT setting does not exists.",
  lottery_parent_min_not_meet: "[Lottery] Does not match with parent minimum PT.",
  lottery_exceeded_parent_pt: "[Lottery] Exceeded parent PT setting.",
  lottery_account_pt_required: "[Lottery] Account PT setting is required.",
  lottery_upline_remaining_required: "[Lottery] Upline remaining PT setting is required.",
  lottery_account_min_required: "[Lottery] Account minimum PT setting is required.",
  lottery_upline_remaining_gt_account_pt: "[Lottery] Upline remaining PT setting is greater than account PT setting.",
  lottery_account_min_gt_pt: "[Lottery] Account minimum PT setting is greater than parent PT setting.",
  bet_type_required: "Bet type is required",
  schedule_1_to_7_required: "Settlement schedule is required",
  schedule_exists: "Settlement schedule does not exists.",
  parent_schedule_not_exists: "Parent settlement schedule does not exists.",
  schedule_1_not_available: "Settlement on Monday is not available.",
  schedule_2_not_available: "Settlement on Tuesday is not available.",
  schedule_3_not_available: "Settlement on Wednesday is not available.",
  schedule_4_not_available: "Settlement on Thursday is not available.",
  schedule_5_not_available: "Settlement on Friday is not available.",
  schedule_6_not_available: "Settlement on Saturday is not available.",
  schedule_7_not_available: "Settlement on Sunday is not available.",
  credit_limit_required: "Credit limit is required.",
  member_credit_limit_required: "Member credit limit is required.",
  wallet_exists: "Account is already exists.",
  member_credit_limit_gt_credit_limit: "Member credit limit is greater than credit limit.",
  parent_wallet_not_exists: "Account does not exists.",
  account_credit_limit_gt_parent: "Account credit limit is greater than parent credit limit.",
  member_credit_limit_gt_parent: "Member credit limit is greater than parent credit limit",
  exceeded_credit_limit: "Exceeded account credit limit.",
  soccer_min_bet_required: "Minimum bet is required.",
  soccer_max_bet_required: "Maximum bet is required.",
  soccer_max_per_match_required: "Maximum bet per match is required",
  soccer_bet_limit_exists: "Bet limit is already exists.",
  soccer_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  soccer_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  soccer_account_max_bet_gt_parent: "Account max bet is greater than parent",
  soccer_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  basketball_min_bet_required: "Minimum bet is required.",
  basketball_max_bet_required: "Maximum bet is required.",
  basketball_max_per_match_required: "Maximum bet per match is required",
  basketball_bet_limit_exists: "Bet limit is already exists.",
  basketball_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  basketball_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  basketball_account_max_bet_gt_parent: "Account max bet is greater than parent",
  basketball_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  tennis_min_bet_required: "Minimum bet is required.",
  tennis_max_bet_required: "Maximum bet is required.",
  tennis_max_per_match_required: "Maximum bet per match is required",
  tennis_bet_limit_exists: "Bet limit is already exists.",
  tennis_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  tennis_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  tennis_account_max_bet_gt_parent: "Account max bet is greater than parent",
  tennis_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  baseball_min_bet_required: "Minimum bet is required.",
  baseball_max_bet_required: "Maximum bet is required.",
  baseball_max_per_match_required: "Maximum bet per match is required",
  baseball_bet_limit_exists: "Bet limit is already exists.",
  baseball_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  baseball_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  baseball_account_max_bet_gt_parent: "Account max bet is greater than parent",
  baseball_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  parlay_min_bet_required: "Minimum bet is required.",
  parlay_max_bet_required: "Maximum bet is required.",
  parlay_max_per_match_required: "Maximum bet per match is required",
  parlay_bet_limit_exists: "Bet limit is already exists.",
  parlay_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  parlay_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  parlay_account_max_bet_gt_parent: "Account max bet is greater than parent",
  parlay_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  esports_min_bet_required: "Minimum bet is required.",
  esports_max_bet_required: "Maximum bet is required.",
  esports_max_per_match_required: "Maximum bet per match is required",
  esports_bet_limit_exists: "Bet limit is already exists.",
  esports_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  esports_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  esports_account_max_bet_gt_parent: "Account max bet is greater than parent",
  esports_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  others_min_bet_required: "Minimum bet is required.",
  others_max_bet_required: "Maximum bet is required.",
  others_max_per_match_required: "Maximum bet per match is required",
  others_bet_limit_exists: "Bet limit is already exists.",
  others_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  others_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  others_account_max_bet_gt_parent: "Account max bet is greater than parent",
  others_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  used_credit_gt_credit_limit: "Used credit limit is greater than credit limit.",
  bet_limit_setting_not_exists: "Bet limit setting does not exists.",
  parent_bet_limit_setting_not_exists: "Parent bet limit setting does not exists.",
  package_not_exists_in_parent: "Parent bet limit package setting does not exists",
  soccer_bet_limit_setting_not_exists: "Soccer bet limit setting does not exixts.",
  soccer_update_interval_violated: "Update interval violated.",
  basketball_bet_limit_setting_not_exists: "Basketball bet limit setting does not exixts.",
  basketball_update_interval_violated: "Update interval violated.",
  tennis_bet_limit_setting_not_exists:"Tennis bet limit setting does not exixts.",
  tennis_update_interval_violated: "Update interval violated.",
  baseball_bet_limit_setting_not_exists:"Baseball bet limit setting does not exixts.",
  baseball_update_interval_violated: "Update interval violated.",
  parlay_bet_limit_setting_not_exists:"Parlay bet limit setting does not exixts.",
  parlay_update_interval_violated: "Update interval violated.",
  esports_bet_limit_setting_not_exists:"Esports bet limit setting does not exixts.",
  esports_update_interval_violated: "Update interval violated.",
  others_bet_limit_setting_not_exists:"Others bet limit setting does not exixts.",
  others_update_interval_violated: "Update interval violated.",
  soccer_parent_bet_limit_setting_not_exists: "Soccer parent bet limit setting does not exixts.",
  soccer_min_bet_lt_parent: "Soccer account min bet is lower than parent.",
  soccer_max_bet_gt_parent: "Soccer account max bet is greater than parent.",
  soccer_max_per_match_gt_parent: "Soccer account max per match is greater than parent.",
  basketball_parent_bet_limit_setting_not_exists: "Basketball parent bet limit setting does not exixts.",
  basketball_min_bet_lt_parent: "Basketball account min bet is lower than parent.",
  basketball_max_bet_gt_parent: "Basketball account max bet is greater than parent.",
  basketball_max_per_match_gt_parent: "Basketball account max per match is greater than parent.",
  tennis_parent_bet_limit_setting_not_exists: "Tennis parent bet limit setting does not exixts.",
  tennis_min_bet_lt_parent: "Tennis account min bet is lower than parent.",
  tennis_max_bet_gt_parent: "Tennis account max bet is greater than parent.",
  tennis_max_per_match_gt_parent: "Tennis account max per match is greater than parent.",
  baseball_parent_bet_limit_setting_not_exists: "Baseball parent bet limit setting does not exixts.",
  baseball_min_bet_lt_parent: "Baseball account min bet is lower than parent.",
  baseball_max_bet_gt_parent: "Baseball account max bet is greater than parent.",
  baseball_max_per_match_gt_parent: "Baseball account max per match is greater than parent.",
  parlay_parent_bet_limit_setting_not_exists: "Parlay parent bet limit setting does not exixts.",
  parlay_min_bet_lt_parent: "Parlay account min bet is lower than parent.",
  parlay_max_bet_gt_parent: "Parlay account max bet is greater than parent.",
  parlay_max_per_match_gt_parent: "Parlay account max per match is greater than parent.",
  esports_parent_bet_limit_setting_not_exists: "ESports parent bet limit setting does not exixts.",
  esports_min_bet_lt_parent: "ESports account min bet is lower than parent.",
  esports_max_bet_gt_parent: "ESports account max bet is greater than parent.",
  esports_max_per_match_gt_parent: "ESports account max per match is greater than parent.",
  others_parent_bet_limit_setting_not_exists: "ESports parent bet limit setting does not exixts.",
  others_min_bet_lt_parent: "ESports account min bet is lower than parent.",
  others_max_bet_gt_parent: "ESports account max bet is greater than parent.",
  others_max_per_match_gt_parent: "ESports account max per match is greater than parent.",
  update_interval_violated: "Update interval violated.",
  exceeded_parent_others: "Exceeded parent others commission setting.",
  exceeded_parent_hdp: "Exceeded parent HDP bet limit setting.",
  no_information_available: "No information is available.",
  request_processing: "Processing request...",
  new_login_id_format_error: "Only small capital letters from a to z and 0 to 9 allowed.",
  account_id_format_error: "Only small capital letters from a to z and 0 to 9 allowed.",
  inactive_account: "Account has been closed/suspended. Please contact operator.",

  sportsbook_account_pt_gt_92: "Super Senior PT cannot greater than 92%",
  pending_result: "Pending result",
  insufficient_balance: "Insufficient balance",
  ok: "Succeed",
  settlement_warning: "Warning: if balance is fully transffered, the highlighted members below will have negative bet credit and consequently, they might lose more than their given credit.",
  jackpot_alert: "For any single progressive jackpot payout exceeding MYR 100,000 (THB 1,000,000),  MMK555 will bear the cost of the full amount.",
  accumulate_alert: "Win limits will reset once payment is settled in transfer list",

  add_key_confirm: "Are you sure want to add key?",
  add_key_success: "Key successfully added!",
  update_key_confirm: "Are you sure want to update key?",
  update_key_success: "Key successfully updated!",

  add_ip_confirm: "Are you sure want to add IP?",
  add_ip_success: "IP successfully added!",
  add_ip_cancel: "Add IP failed!",
  delete_ip_confirm: "Are you sure want to delete IP?",
  delete_ip_success: "IP successfully deleted!",
  delete_ip_cancel: "Delete IP failed!",
  update_ip_whitelist_success: "IP whitelist successfully updated!",
  ip_not_exists: "IP does not exists.",
  ip_exists: "IP is already exists.",
  target_account_id_contain_reserved_word: "Username contain reserved words",
  update_bet_limit_setting: "Are you sure want to update bet limit setting?",
  update_bet_limit_setting_cancel: "Update bet limit failed.",
  update_bet_limit_succeed: "Bet limit successfully updated!",

  update_account_hdp_packages_confirm: "Are you sure want to update account hdp packages?",
  update_account_hdp_packages_cancel: "Update account hdp packages failed.",
  update_account_hdp_packages_success: "Account hdp packages successfully updated!",

  cash_deposit_confirm: "Are you sure want to deposit cash?",
  cash_deposit_cancel: "Deposit cash failed.",
  cash_deposit_success: "Deposit cash successfully updated!",

  cash_withdrawal_confirm: "Are you sure want to withdraw cash?",
  cash_withdrawal_cancel: "Withdraw cash failed.",
  cash_withdrawal_success: "Withdraw cash successfully updated!",

  welcome_to_mmk555: "Welcome To MMK555!",
  invalid_parameter: "Invalid parameter.",
  action_by_required: "Action by is required.",
  invalid_action_by: "Invalid action by.",
  invalid_account_id: "Invalid account ID.",
  invalid_profile_id: "Invalid profile ID.",
  session_token_required: "Session token is required.",
  invalid_session_token: "Invalid session token.",
  invalid_target_account_id: "Invalid target account ID.",
  invalid_search_id: "Invalid search ID.",
  invalid_start_date: "Invalid start date.",
  invalid_end_date: "Invalid end date.",
  invalid_page_number: "Invalid page number.",
  invalid_page_size: "Invalid page size.",
  invalid_account_status: "Invalid account status.",
  invalid_soccer_min_bet: "Invalid min bet.",
  invalid_soccer_max_bet: "Invalid max bet.",
  invalid_soccer_max_per_match: "Invalid maximum bet per match.",
  soccer_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  soccer_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_basketball_min_bet: "Invalid min bet.",
  invalid_basketball_max_bet: "Invalid max bet.",
  invalid_basketball_max_per_match: "Invalid maximum bet per match.",
  basketball_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  basketball_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_tennis_min_bet: "Invalid min bet.",
  invalid_tennis_max_bet: "Invalid max bet.",
  invalid_tennis_max_per_match: "Invalid maximum bet per match.",
  tennis_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  tennis_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_baseball_min_bet: "Invalid min bet.",
  invalid_baseball_max_bet: "Invalid max bet.",
  invalid_baseball_max_per_match: "Invalid maximum bet per match.",
  baseball_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  baseball_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_parlay_min_bet: "Invalid min bet.",
  invalid_parlay_max_bet: "Invalid max bet.",
  invalid_parlay_max_per_match: "Invalid maximum bet per match.",
  parlay_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  parlay_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_esports_min_bet: "Invalid min bet.",
  invalid_esports_max_bet: "Invalid max bet.",
  invalid_esports_max_per_match: "Invalid maximum bet per match.",
  esports_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  esports_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_others_min_bet: "Invalid min bet.",
  invalid_others_max_bet: "Invalid max bet.",
  invalid_others_max_per_match: "Invalid maximum bet per match.",
  others_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  others_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_passwords: "Invalid password.",
  invalid_account_type: "Invalid account type.",
  invalid_full_name: "Invalid full name.",
  invalid_contact_email: "Invalid contact email.",
  invalid_contact_phone: "Invalid contact phone.",
  invalid_audit_by: "Invalid audit by.",
  invalid_remark: "Invalid remark.",
  target_profile_id_required: "Target profile ID is required.",
  invalid_target_profile_id: "Invalid target profile ID.",
  invalid_sub_login_id: "Invalid sub login ID.",
  invalid_sort_key: "Invalid sort key.",
  invalid_sort_type: "Invalid sort type.",
  invalid_new_login_id: "Invalid new login ID.",
  invalid_new_password: "Invalid new password.",
  invalid_security_tag: "Invalid security tag.",
  invalid_security_code: "Invalid security code.",
  authority_option_required: "Please choose at least one authority.",
  invalid_authority_option: "Invalid authority option.",
  ip_required: "IP is required.",
  invalid_ip: "Invalid IP",
  suffix_required: "Suffix is required.",
  invalid_suffix: "Invalid suffix.",
  type_required: "Type is required.",
  invalid_type: "Invalid type.",
  callbackurl_required: "Callbackurl is required.",
  invalid_callbackurl: "Invalid callbackurl.",
  email_required: "Email is required.",
  invalid_email: "Invalid email.",
  apistatus_required: "Apistatus is required.",
  invalid_apistatus: "Invalid apistatus.",
  invalid_login_id: "Invalid login ID.",
  invalid_loginsource: "Invalid login source.",
  hdp_package_required: "HDP package required.",
  invalid_target_login_id: "Invalid target login ID.",
  status_required: "Status is required.",
  invalid_status: "Invalid status.",
  amount_required: "Amount is required.",
  invalid_amount: "Invalid amount.",
  method_required: "Method is required.",
  invalid_method: "Invalid method.",
  soccer_hdp_upline_pt_required: "HDP upline PT is required.",
  soccer_hdp_account_pt_required: "HDP account PT is required.",
  soccer_hdp_upline_remaining_required: "HDP upline remaining is required.",
  soccer_hdp_account_min_required: "HDP account minimum is required.",
  soccer_hdp_pt_setting_not_exists: "HDP PT setting does not exists.",
  soccer_hdp_parent_pt_not_exists: "HDP parent PT does not exists.",
  soccer_hdp_exceeded_parent_pt: "HDP exceeded parent PT.",
  soccer_hdp_upline_remaining_gt_account_pt: "HDP upline remaining greater than account PT.",
  soccer_hdp_account_min_gt_pt: "HDP account minimum greater than PT",
  soccer_hdp_account_pt_lt_downline: "HDP account PT lower than downline.",

  invalid_soccer_hdp_upline_pt: "Invalid HDP upline PT.",
  soccer_1x2_upline_pt_required: "1x2 upline PT is required.",
  soccer_1x2_account_pt_required: "1x2 account PT is required.",
  soccer_1x2_upline_remaining_required: "1x2 upline remaining is required.",
  soccer_1x2_account_min_required: "1x2 account minimum is required.",
  soccer_1x2_pt_setting_not_exists: "1x2 PT setting does not exists.",
  soccer_1x2_parent_pt_not_exists: "1x2 parent PT does not exists.",
  soccer_1x2_exceeded_parent_pt: "1x2 exceeded parent PT.",
  soccer_1x2_upline_remaining_gt_account_pt: "1x2 upline remaining greater than account PT.",
  soccer_1x2_account_min_gt_pt: "1x2 account minimum greater than PT",
  soccer_1x2_account_pt_lt_downline: "1x2 account PT lower than downline.",

  invalid_soccer_1x2_upline_pt: "Invalid 1x2 upline PT.",
  soccer_others_upline_pt_required: "Others upline PT is required.",
  soccer_others_account_pt_required: "Others account PT is required.",
  soccer_others_upline_remaining_required: "Others upline remaining is required.",
  soccer_others_account_min_required: "Others account minimum is required.",
  soccer_others_pt_setting_not_exists: "Others PT setting does not exists.",
  soccer_others_parent_pt_not_exists: "Others parent PT does not exists.",
  soccer_others_exceeded_parent_pt: "Others exceeded parent PT.",
  soccer_others_upline_remaining_gt_account_pt: "Others upline remaining greater than account PT.",
  soccer_others_account_min_gt_pt: "Others account minimum greater than PT",
  soccer_others_account_pt_lt_downline: "Others account PT lower than downline.",

  invalid_soccer_others_upline_pt: "Invalid others upline PT.",
  parlay_upline_pt_required: "Parlay upline PT is required.",
  parlay_account_pt_required: "Parlay account PT is required.",
  parlay_upline_remaining_required: "Parlay upline remaining is required.",
  parlay_account_min_required: "Parlay account minimum is required.",
  parlay_pt_setting_not_exists: "Parlay PT setting does not exists.",
  parlay_parent_pt_not_exists: "Parlay parent PT does not exists.",
  parlay_exceeded_parent_pt: "Parlay exceeded parent PT.",
  parlay_upline_remaining_gt_account_pt: "Parlay upline remaining greater than account PT.",
  parlay_account_min_gt_pt: "Parlay account minimum greater than PT",
  parlay_account_pt_lt_downline: "Parlay account PT lower than downline.",

  invalid_parlay_upline_pt: "Invalid parlay upline PT .",
  invalid_member_id: "Invalid member ID.",
  invalid_sport_type: "Invalid sport type.",
  invalid_league_id: "Invalid league ID.",
  invalid_match_id: "Invalid match ID.",
  working_date_required: "Working date is required.",
  invalid_working_date: "Invalid working date.",
  game_type_required: "Game type is required.",
  invalid_game_type: "Invalid game type.",
  bet_id_required: "Bet ID is required.",
  invalid_bet_id: "Invalid bet ID.",
  hdp_packages_not_exists: "HDP package does not exists.",
  parent_hdp_packages_not_exists: "Parent HDP package does not exists.",
  invalid_bet_type: "Invalid bet type.",
  invalid_match_id: "Invalid Match ID.",
  invalid_home_running_score: "Invalid Home Running Score.",
  invalid_away_running_score: "Invalid Away Running Score.",
  invalid_home_away: "Invalid Home Away.",

  operator_account_not_exists: "Operator account does not exists.",
  insert_main_failed: "Insert main failed.",
  delete_child_failed: "Delete child failed.",
  insert_child_failed: "Insert child failed.",
  invalid_operator: "Invalid operator.",
  invalid_master: "Invalid master.",
  duplicate_suffix: "Duplicate suffix.",
  insert_error: "Insert error.",
  allow_to_add_multiple_ip: "Allow to add multiple IP, eg. 192.168.1.1,192.168.1.2",
  only_allow_proper_url: "URL must be start with http or https, eg. https://xxxxxx.com",

  filter_yesterday_balance: "Show Yesterday Balance not equal to 0",

  create_promotion_confirm: "Are you sure want to create promotion?",
  create_promotion_cancel: "Create promotion failed",
  create_promotion_success: "Promotion successfully created!",

  create_admin_confirm: "Are you sure want to create admin?",
  create_admin_cancel: "Create admin failed",
  create_admin_success: "Admin successfully created!",

  approve_ticket_confirm: "Are you sure want to approve ticket?",
  approve_ticket_cancel: "Approve ticket failed",
  reject_ticket_confirm: "Are you sure want to reject ticket?",
  reject_ticket_cancel: "Reject ticket failed",
  process_ticket_success: "Ticket successfully processed!",
  process_ticket_cancel: "Process ticket failed",

  update_promotion_status_confirm: "Are you sure want to update promotion status?",
  update_promotion_status_cancel: "Update promotion status failed.",
  update_promotion_status_success: "Promotion status successfully updated!",

  //kenny side error
  noChanges: "No changes!",
  permissionDenied: "Permission denied!",
  accountIdRequired: "Account ID is required.",
  parentIdRequired: "Parent ID is required.",
  passwordRequired: "Password is required.",
  amountRequired: "Amount is required.",
  ipAddressRequired: "IP address is required.",
  transactionIdRequired: "Transaction ID is required.",
  auditByRequired: "Audit by is required.",
  systemTypeRequired: "System type is required.",
  currencyRequired: "Currency is required.",
  downlineLimitRequired: "Downline limit is required.",
  creditLimitRequired: "Credit limit is required.",
  memberCreditLimitRequired: "Member credit limit is required.",
  settlementScheduleRequired: "Settlement schedule is required.",
  hdpUplinePtRequired: "HDP upline PT is required.",
  hdpAccountPtRequired: "HDP account PT is required.",
  hdpUplineRemainingRequired: "HDP upline remaining is required.",
  hdpAccountMinRequired: "HDP account minimum is required.",
  oneXtwoUplinePtRequired: "1x2 upline PT is required.",
  oneXtwoAccountPtRequired: "1x2 account PT is required.",
  oneXtwoUplineRemainingRequired: "1x2 upline remaining is required.",
  oneXtwoAccountMinRequired: "1x2 account minimum is required.",
  othersUplinePtRequired: "Others upline PT is required.",
  othersAccountPtRequired: "Others account PT is required.",
  othersUplineRemainingRequired: "Others upline remaining is required.",
  othersAccountMinRequired: "Others account minimum is required.",
  parlayUplinePtRequired: "Parlay upline PT is required.",
  parlayAccountPtRequired: "Parlay account PT is required.",
  parlayUplineRemainingRequired: "Parlay upline remaining is required.",
  parlayAccountMinRequired: "Parlay account minimum is required.",
  livecasinoUplinePtRequired: "[Livecasino] upline PT is required.",
  livecasinoAccountPtRequired: "[Livecasino] account PT is required.",
  livecasinoUplineRemainingRequired: "[Livecasino] upline remaining is required.",
  livecasinoAccountMinRequired: "[Livecasino] account minimum is required.",
  slotsUplinePtRequired: "[Slots] upline PT is required.",
  slotsAccountPtRequired: "[Slots] account PT is required.",
  slotsUplineRemainingRequired: "[Slots] upline remaining is required.",
  slotsAccountMinRequired: "[Slots] account minimum is required.",

  winLimitRequired: "Win limit is required.",
  dailyResetRequired: "Daily reset is required.",
  subAccountIdRequired: "Sub account ID is required.",
  statusRequired: "Status is required.",
  newPasswordRequired: "New password is required.",
  loginIdRequired: "Login ID is required.",
  profileIdRequired: "Profile ID is required.",
  securityTagRequired: "Security tag is required.",
  securityCodeRequired: "Security code is required.",
  providerCodeRequired: "Provider code is required.",
  startDateRequired: "Start date is required.",
  endDateRequired: "End date is required.",
  searchIdRequired: "Search ID is required.",
  rateRequired: "Rate is required.",
  authTokenRequired: "Auth token is required.",
  hdpCommPackageRequired: "HDP commission package is required.",
  livecasinoBetLimitPackageRequired: "[Livecasino] bet limit package is required.",
  actionRequired: "Action is required.",
  promotionIdRequired: "Promotion ID is required.",
  promotionNameRequired: "Promotion name is required.",
  minDepositRequired: "Minimum deposit is required.",
  bonusRateRequired: "Bonus rate is required.",
  hdpCommRequired: "HDP commission is required.",
  oneXtwoCommRequired: "1x2 commission is required.",
  othersCommRequired: "Others commission is required.",
  livecasinoCommRequired: "[Livecasino] commission is required.",
  slotsCommRequired: "[Slots] commission is required.",
  rolloverRequired: "Rollover is required.",
  criteriaRequired: "Criteria is required.",
  platformRequired: "Platform is required.",
  ticketIdRequired: "Ticket ID is required.",
  resultIdRequired: "Result ID is required.",
  soccerMinBetRequired: "Soccer minimum bet is required.",
  soccerMaxBetRequired: "Soccer maximum bet is required.",
  soccerMaxPerMatchRequired: "Soccer maximum bet per match is required.",

  basketballMinBetRequired: "Basketball minimum bet is required.",
  basketballMaxBetRequired: "Basketball maximum bet is required.",
  basketballMaxPerMatchRequired: "Basketball maximum bet per match is required.",

  tennisMinBetRequired: "Tennis minimum bet is required.",
  tennisMaxBetRequired: "Tennis maximum bet is required.",
  tennisMaxPerMatchRequired: "Tennis maximum bet per match is required.",

  baseballMinBetRequired: "Baseball minimum bet is required.",
  baseballMaxBetRequired: "Baseball maximum bet is required.",
  baseballMaxPerMatchRequired: "Baseball maximum bet per match is required.",

  parlayMinBetRequired: "Parlay minimum bet is required.",
  parlayMaxBetRequired: "Parlay maximum bet is required.",
  parlayMaxPerMatchRequired: "Parlay maximum bet per match is required.",

  esportsMinBetRequired: "Esports minimum bet is required.",
  esportsMaxBetRequired: "Esports maximum bet is required.",
  esportsMaxPerMatchRequired: "Esports maximum bet per match is required.",

  othersMinBetRequired: "Others minimum bet is required.",
  othersMaxBetRequired: "Others maximum bet is required.",
  othersMaxPerMatchRequired: "Others maximum bet per match is required.",

  hdpMmoUplinePtRequired: "HDP MMO upline PT is required.",
  hdpMmoAccountPtRequired: "HDP MMO account PT is required.",
  hdpMmoUplineRemainingRequired: "HDP MMO upline remaining is required.",
  hdpMmoAccountMinRequired: "HDP MMO account minimum is required.",
  hdpMmoCommRequired: "HDP MMO commission is required.",
  parlayMmoACommRequired: "Parlay MMO A commission is required.",
  parlayMmoBCommRequired: "Parlay MMO B commission is required.",
  transferIdRequired: "Transfer ID is required.",
  betTimeRequired: "Bet time is required.",
  turnoverRequired: "Turnover is required.",
  payoutRequired: "Payout is required.",
  winloseRequired: "Winlose is required.",
  rawMessageRequired: "Raw message is required.",
  authStatusRequired: "Auth status is required.",
  dateRequired: "Date is required.",
  betIdRequired: "Bet ID is required.",
  betStatusRequired: "Bet status is required.",
  betAmountRequired: "Bet amount is required.",
  isParlayRequired: "Is parlay is required.",
  parlayMmoUplinePtRequired: "Parlay MMO upline PT is required.",
  parlayMmoAccountPtRequired: "Parlay MMO account PT is required.",
  parlayMmoUplineRemainingRequired: "Parlay MMO upline remaining is required.",
  parlayMmoAccountMinRequired: "Parlay MMO account minimum is required.",
  betTypeRequired: "Bet type is required.",

  hdpInvalidPt: "Invalid HDP PT.",
  hdpUplineRemainingGreaterThanAccountPt: "HDP upline remaining greater than account PT.",
  hdpAccountMinGreaterThanAccountPt: "HDP account minimum greater than account PT.",
  hdpPtSettingExists: "HDP PT setting is already exists.",

  oneXtwoInvalidPt: "Invalid 1x2 PT.",
  oneXtwoUplineRemainingGreaterThanAccountPt: "1x2 upline remaining greater than account PT.",
  oneXtwoAccountMinGreaterThanAccountPt: "1x2 account minimum greater than account PT.",
  oneXtwoPtSettingExists: "1x2 PT setting is already exists.",

  othersInvalidPt: "Invalid others PT.",
  othersUplineRemainingGreaterThanAccountPt: "Others upline remaining greater than account PT.",
  othersAccountMinGreaterThanAccountPt: "Others account minimum greater than account PT.",
  othersPtSettingExists: "Others PT setting is already exists.",

  parlayInvalidPt: "Invalid parlay PT.",
  parlayUplineRemainingGreaterThanAccountPt: "Parlay upline remaining greater than account PT.",
  parlayAccountMinGreaterThanAccountPt: "Parlay account minimum greater than account PT.",
  parlayPtSettingExists: "Parlay PT setting is already exists.",

  livecasinoInvalidPt: "Invalid [livecasino] PT.",
  livecasinoUplineRemainingGreaterThanAccountPt: "[Livecasino] upline remaining greater than account PT.",
  livecasinoAccountMinGreaterThanAccountPt: "[Livecasino] account minimum greater than account PT.",
  livecasinoPtSettingExists: "[Livecasino] PT setting is already exists.",

  slotsInvalidPt: "Invalid [slots] PT.",
  slotsUplineRemainingGreaterThanAccountPt: "[Slots] upline remaining greater than account PT.",
  slotsAccountMinGreaterThanAccountPt: "[Slots] account minimum greater than account PT.",
  slotsPtSettingExists: "[Slots] PT setting is already exists.",

  hdpParentPtNotExists: "HDP parent PT setting not exists.",
  hdpParentMinNotMeet: "HDP does not match with parent minimum PT.",
  hdpExceededParentPt: "HDP exceeded parent PT setting.",

  oneXtwoParentPtNotExists: "1x2 parent PT setting not exists.",
  oneXtwoParentMinNotMeet: "1x2 does not match with parent minimum PT.",
  oneXtwoExceededParentPt: "1x2 exceeded parent PT setting.",

  othersParentPtNotExists: "Others parent PT setting not exists.",
  othersParentMinNotMeet: "Others does not match with parent minimum PT.",
  othersExceededParentPt: "Others exceeded parent PT setting.",

  parlayParentPtNotExists: "Parlay parent PT setting not exists.",
  parlayParentMinNotMeet: "Parlay does not match with parent minimum PT.",
  parlayExceededParentPt: "Parlay exceeded parent PT setting.",

  livecasinoParentPtNotExists: "Parlay parent PT setting not exists.",
  livecasinoParentMinNotMeet: "Parlay does not match with parent minimum PT.",
  livecasinoExceededParentPt: "Parlay exceeded parent PT setting.",

  sportsbookParentCommSettingNotExists: "Sportsbook parent commission setting not exists.",
  sportsbookCommSettingExists: "Sportsbook commission setting is already exists.",
  livecasinoCommSettingExists: "[Livecasino] commission setting is already  exists.",
  slotsCommSettingExists: "[Slots] commission setting is already exists.",
  slotsParentPtNotExists: "[Slots] parent PT setting not exists.",
  slotsParentMinNotMeet: "[Slots] does not match with parent minimum PT.",
  slotsExceededParentPt: "[Slots] exceeded parent PT setting.",

  oneXtwoExceededParentComm: "1x2 exceeded parent commission setting.",
  accountInactive: "Inactive account.",

  soccerMinBetGreaterThanMaxBet: "Minimum bet is greater than maximum bet.",
  soccerMaxBetGreaterThanMaxPerMatch: "Maximum bet is greater than maximum bet per match.",
  soccerMinBetLowerThanParent: "Account min bet is lower than parent.",
  soccerMaxBetGreaterThanParent: "Account max bet is greater than parent.",
  soccerMaxPerMatchGreaterThanParent: "Account maximum bet per match is greater than parent.",

  basketballMinBetGreaterThanMaxBet: "Minimum bet is greater than maximum bet.",
  basketballMaxBetGreaterThanMaxPerMatch: "Maximum bet is greater than maximum bet per match.",
  basketballMinBetLowerThanParent: "Account min bet is lower than parent.",
  basketballMaxBetGreaterThanParent: "Account max bet is greater than parent.",
  basketballMaxPerMatchGreaterThanParent: "Account maximum bet per match is greater than parent.",

  tennisMinBetGreaterThanMaxBet: "Minimum bet is greater than maximum bet.",
  tennisMaxBetGreaterThanMaxPerMatch: "Maximum bet is greater than maximum bet per match.",
  tennisMinBetLowerThanParent: "Account min bet is lower than parent.",
  tennisMaxBetGreaterThanParent: "Account max bet is greater than parent.",
  tennisMaxPerMatchGreaterThanParent: "Account maximum bet per match is greater than parent.",

  baseballMinBetGreaterThanMaxBet: "Minimum bet is greater than maximum bet.",
  baseballMaxBetGreaterThanMaxPerMatch: "Maximum bet is greater than maximum bet per match.",
  baseballMinBetLowerThanParent: "Account min bet is lower than parent.",
  baseballMaxBetGreaterThanParent: "Account max bet is greater than parent.",
  baseballMaxPerMatchGreaterThanParent: "Account maximum bet per match is greater than parent.",

  parlayMinBetGreaterThanMaxBet: "Minimum bet is greater than maximum bet.",
  parlayMaxBetGreaterThanMaxPerMatch: "Maximum bet is greater than maximum bet per match.",
  parlayMinBetLowerThanParent: "Account min bet is lower than parent.",
  parlayMaxBetGreaterThanParent: "Account max bet is greater than parent.",
  parlayMaxPerMatchGreaterThanParent: "Account maximum bet per match is greater than parent.",

  esportsMinBetGreaterThanMaxBet: "Minimum bet is greater than maximum bet.",
  esportsMaxBetGreaterThanMaxPerMatch: "Maximum bet is greater than maximum bet per match.",
  esportsMinBetLowerThanParent: "Account min bet is lower than parent.",
  esportsMaxBetGreaterThanParent: "Account max bet is greater than parent.",
  esportsMaxPerMatchGreaterThanParent: "Account maximum bet per match is greater than parent.",

  othersMinBetGreaterThanMaxBet: "Minimum bet is greater than maximum bet.",
  othersMaxBetGreaterThanMaxPerMatch: "Maximum bet is greater than maximum bet per match.",
  othersMinBetLowerThanParent: "Account min bet is lower than parent.",
  othersMaxBetGreaterThanParent: "Account max bet is greater than parent.",
  othersMaxPerMatchGreaterThanParent: "Account maximum bet per match is greater than parent.",

  soccerBetLimitExists: "Bet limit is already exists.",
  basketballBetLimitExists: "Bet limit is already exists.",
  tennisBetLimitExists: "Bet limit is already exists.",
  baseballBetLimitExists: "Bet limit is already exists.",
  parlayBetLimitExists: "Bet limit is already exists.",
  esportsBetLimitExists: "Bet limit is already exists.",
  othersBetLimitExists: "Bet limit is already exists.",

  hdpMmoInvalidPt: "Invalid HDP MMO PT.",
  hdpMmoUplineRemainingGreaterThanAccountPt: "HDP MMO upline remaining greater than account PT.",
  hdpMmoAccountMinGreaterThanAccountPt: "HDP MMO account min greater than account PT.",
  hdpMmoPtSettingExists: "HDP MMO PT setting is already exists.",
  mmoCommSettingExists: "MMO commission setting is already exists.",
  memberCreditLimitGreaterThanCreditLimit: "Member credit limit greater than credit limit.",
  atLeastOneDayOfWeekShouldBeEnabled: "At least one day of week should be enabled.",
  walletExists: "Wallet is already exists.",
  settlementScheduleExists: "Settlement schedule is already exists.",
  accountExists: "Account is already exists.",
  downlineLimitExceeded: "Exceeded downline limit.",
  mondayNotAvailable: "Settlement on Monday is not available.",
  tuesdayNotAvailable: "Settlement on Tuesday is not available.",
  wednesdayNotAvailable: "Settlement on Wednesday is not available.",
  thursdayNotAvailable: "Settlement on Thursday is not available.",
  fridayNotAvailable: "Settlement on Friday is not available.",
  saturdayNotAvailable: "Settlement on Saturday is not available.",
  sundayNotAvailable: "Settlement on Sunday is not available.",
  invalidSystemType: "Invalid system type.",
  parentSettlementScheduleNotExists: "Parent settlement schedule not exists.",
  othersExceededParentComm: "Others exceeded parent commission.",
  accountNotExists: "Account not exists.",
  parlayMmoInvalidPt: "Invalid parlay MMO PT.",
  parlayMmoUplineRemainingGreaterThanAccountPt: "Parlay MMO upline remaining greater than account PT.",
  parlayMmoAccountMinGreaterThanAccountPt: "Parlay MMO account min greater than account PT.",
  parlayMmoPtSettingExists: "Parlay MMO PT setting is already exists.",

  hdpMmoParentPtNotExists: "HDP MMO parent PT setting not exists.",
  hdpMmoParentMinNotMeet: "HDP MMO does not match with parent minimum PT.",
  hdpMmoExceededParentPt: "HDP MMO exceeded parent PT setting.",

  parlayMmoParentPtNotExists: "Parlay MMO parent PT setting not exists.",
  parlayMmoParentMinNotMeet: "Parlay MMO does not match with parent minimum PT.",
  parlayMmoExceededParentPt: "Parlay MMO exceeded parent PT setting.",

  invalidHdpPackage: "Invalid HDP Package.",
  hdpExceededParentComm: "Exceeded parent HPD commission setting.",
  hdpaExceededParentComm: "Exceeded parent HPD(A) commission setting.",
  hdpbExceededParentComm: "Exceeded parent HPD(B) commission setting.",
  hdpcExceededParentComm: "Exceeded parent HPD(C) commission setting.",
  hdpdExceededParentComm: "Exceeded parent HPD(D) commission setting.",
  hdpeExceededParentComm: "Exceeded parent HPD(E) commission setting.",
  hdpfExceededParentComm: "Exceeded parent HPD(F) commission setting.",
  hdpgExceededParentComm: "Exceeded parent HPD(G) commission setting.",
  hdphExceededParentComm: "Exceeded parent HPD(H) commission setting.",
  hdpiExceededParentComm: "Exceeded parent HPD(I) commission setting.",
  hdpjExceededParentComm: "Exceeded parent HPD(J) commission setting.",

  livecasinoParentCommSettingNotExists: "[Livecasino] parent commission setting not exists.",
  livecasinoExceededParentComm: "[Livecasino] exceeded parent commission setting.",
  slotsParentCommSettingNotExists: "[Slots] parent commission setting not exists.",
  slotsExceededParentComm: "[Slots] exceeded parent commission setting.",

  sportsbookParentBetLimitNotExists: "Parent bet limit does not exists.",

  soccerParentBetLimitNotExists: "Soccer parent bet limit does not exists.",
  basketballParentBetLimitNotExists: "Basketball parent bet limit does not exists.",
  tennisParentBetLimitNotExists: "Tennis parent bet limit does not exists.",
  baseballParentBetLimitNotExists: "Baseball parent bet limit does not exists.",
  parlayParentBetLimitNotExists: "Parlay parent bet limit does not exists.",
  esportsParentBetLimitNotExists: "ESports parent bet limit does not exists.",
  othersParentBetLimitNotExists: "Others parent bet limit does not exists.",

  livecasinoBetLimitExists: "[Livecasino] bet limit is already exists.",
  livecasinoInvalidBetLimitPackage: "Invalid [Livecasino] bet limit package.",
  livecasinoParentBetLimitNotExists: "[Livecasino] parent bet limit not exists.",
  insufficientAvailableCreditLimit: "Insufficient available credit limit.",
  creditLimitGreaterThanParentMemberCreditLimit: "Credit limit greater than parent member credit limit.",
  accountNotBlock: "Account is not block.",
  settlementScheduleNotExists: "Settlement schedule does not exists.",
  walletNotExists: "Wallet does not exists.",
  creditLimitGreaterThanParentCreditLimit: "Credit limit greater than parent credit limit.",
  memberCreditLimitGreaterThanParentMemberCreditLimit: "Member credit limit greater than parent member credit limit.",
  usedCreditGreaterThanCreditLimit: "Used credit greater than credit limit.",
  invalidStatus: "Invalid status.",
  samePassword: "Same password.",
  invalidPassword: "Invalid password.",
  secondaryAccountExists: "Secondayr account is already exists.",
  invalidSecurityCode: "Invalid security code.",
  
  sportsbookBetLimitNotExists: "Bet limit does not exists.",
  soccerBetLimitNotExists: "Soccer bet limit does not exists.",
  basketballBetLimitNotExists: "Basketball bet limit does not exists.",
  tennisBetLimitNotExists: "Tennis bet limit does not exists.",
  baseballBetLimitNotExists: "Baseball bet limit does not exists.",
  parlayBetLimitNotExists: "Parlay bet limit does not exists.",
  esportsBetLimitNotExists: "ESports bet limit does not exists.",
  othersBetLimitNotExists: "Others bet limit does not exists.",

  livecasinoBetLimitPackageNotExists: "[Livecasino] bet limt package does not exists.",
  sportsbookPtSettingNotExists: "PT setting does not exists.",
  hdpPtSettingNotExists: "HDP PT setting does not exists.",
  oneXtwoPtSettingNotExists: "1x2 PT setting does not exists.",
  othersPtSettingNotExists: "Others PT setting does not exists.",
  sportsbookParentPtSettingNotExists: "Parent PT setting does not exists.",
  hdpPtLowerThanDownline: "HDP PT lower than downline.",
  oneXtwoPtLowerThanDownline: "1x2 PT lower than downline.",
  othersPtLowerThanDownline: "Others PT lower than downline.",
  parlayPtLowerThanDownline: "Parlay PT lower than downline.",
  parlayPtSettingNotExists: "Parlay PT setting does not exists.",
  hdpMmoPtSettingNotExists: "HDP MMOP PT setting does not exists.",
  parlayMmoPtSettingNotExists: "Parlay MMOP PT setting does not exists.",
  hdpMmoPtLowerThanDownline: "HDP MMOP PT setting lower than downline.",
  parlayMmoPtLowerThanDownline: "Parlay MMOP PT setting lower than downline.",
  slotsPtSettingNotExists: "[Slots] PT setting does not exists.",
  slotsPtLowerThanDownline: "[Slots] PT lower than downline.",
  livecasinoPtSettingNotExists: "[Livecasino] PT setting does not exists.",
  livecasinoPtLowerThanDownline: "[Livecasino] PT lower than downline.",
  livecasinoCommSettingNotExists: "[Livecasino] commission setting does not exists.",
  slotsCommSettingNotExists: "[Slots] commission setting does not exists.",
  sportsbookCommSettingNotExists: "Commission setting does not exists.",
  mmoCommSettingNotExists: "MMO commission setting does not exists.",
  mmoParentCommSettingNotExists: "MMO parent commission setting does not exists.",
  parentProviderSettingNotExists: "Parent provider setting does not exists.",
  parentProviderDisabled: "Parent provider is disabled.",
  providerSettingNotExists: "Provider setting does not exists.",
  invalidAmount: "Invalid amount.",
  amountGreaterThanYesterdayBalance: "Amount greater than yesterday balance.",
  insufficientBalance: "Insufficient balance.",
  amountGreaterThanAccountBalance: "Amount greater than account balance.",
  pendingResultInGame: "Pending result in game.",
  startDateGreaterThanEndDate: "Start date greate than end date.",
  currencyNotExists: "Currency does not exists.",
  currencyExists: "Currency is already exists.",
  incompleteAccountLine: "Incomplete account line.",
  noAccumulateWin: "No accumulate win.",
  invalidSession: "Invalid session.",
  sessionExpired: "Session expired.",
  promotionExists: "Promotion is already exists.",
  invalidCriteria: "Invalid criteria.",
  promotionNotExists: "Promotion does not exists.",
  ticketNotExists: "Ticket does not exists.",
  duplicateDebitRecord: "Duplicate debit record.",
  duplicateCreditRecord: "Duplicate credit record.",
  debitRecordNotExists: "Debit record does not exists.",
  minimumDepositNotMeet: "Does not match minimum deposit.",
  duplicateBet: "Duplicate bet.",
  invalidProviderCode: "Invalid provider code.",
  resultExists: "Result is already exists.",
  unableSPProcess: "Error processing.",
  updateTooFrequent: "Update too frequent.",
  undefined: "Undefined error.",
  dateRangeAllowSixMonths: "Date range only allow select up to 6 months.",
  accountBlock: "Your account has been blocked.",
  allFieldsRequired: "All fields is required.",

  ticket_id_required: "Ticket ID is required.",
  invalid_ticket_id: "Invalid ticket ID.",
  action_status_required: "Action status is required.",
  invalid_action_status: "Invalid action status.",
  invalid_request_type: "Invalid request type.",
  invalid_ticket_status: "Invalid ticket status.",
  platform_required: "Platform is required.",
  invalid_platform: "Invalid platform.",
  currency_required: "Currency is required.",
  invalid_currency: "Invalid currency.",
  provider_code_required: "Provider code is required.",
  invalid_provider_code: "Invalid provider code.",
  new_status_required: "New status is required.",
  invalid_new_status: "Invalid new status.",
  promotion_id_required: "Promotion ID is required.",
  invalid_promotion_id: "Invalid promotion ID.",
  promotion_name_required: "Promotion name is required.",
  invalid_promotion_name: "Invalid promotion name.",
  min_deposit_required: "Minimum deposit is required.",
  invalid_min_deposit: "Invalid minimum deposit.",
  bonus_rate_required: "Bonus rate is required.",
  invalid_bonus_rate: "Invalid bonus rate.",
  rollover_required: "Rollover is required.",
  invalid_rollover: "Invalid rollover.",
  criteria_required: "Criteria is required.",
  invalid_criteria: "Invalid criteria.",
  result_id_required: "Result ID is required.",
  invalid_result_id: "Invalid result ID.",
  monday_required: "Monday is required.",
  tuesday_required: "Tuesday is required.",
  wednesday_required: "Wednesday is required.",
  thursday_required: "Thursday is required.",
  friday_required: "Friday is required.",
  saturday_required: "Saturday is required.",
  sunday_required: "Sunday is required.",
  daily_reset_required: "Daily reset is required.",
  comm_hdp_packages_required: "Commission HDP packages is required.",
  invalid_comm_hdp_packages: "Invalid commission HDP packages.",
  livecasino_bet_limit_package_required: "[Livecasino] bet limit packages is required.",
  invalid_livecasino_bet_limit_package: "Invalid [livecasino] bet limit packages.",
  win_limit_multiplier_required: "Win limit is required.",

  hdp_upline_pt_required: "HDP upline PT is required.",
  hdp_account_pt_required: "HDP account PT is required.",
  hdp_upline_remaining_required: "HDP upline remaining is required.",
  hdp_account_min_required: "HDP account minimum is required.",

  oxt_upline_pt_required: "1x2 upline PT is required.",
  oxt_account_pt_required: "1x2 account PT is required.",
  oxt_upline_remaining_required: "1x2 upline remaining is required.",
  oxt_account_min_required: "1x2 account minimum is required.",

  others_upline_pt_required: "Others upline PT is required.",
  others_account_pt_required: "Others account PT is required.",
  others_upline_remaining_required: "Others upline remaining is required.",
  others_account_min_required: "Others account minimum is required.",

  parlay_upline_pt_required: "Parlay upline PT is required.",
  parlay_account_pt_required: "Parlay account PT is required.",
  parlay_upline_remaining_required: "Parlay upline remaining is required.",
  parlay_account_min_required: "Parlay account minimum is required.",

  slots_upline_pt_required: "[Slots] upline PT is required.",
  slots_account_pt_required: "[Slots] account PT is required.",
  slots_upline_remaining_required: "[Slots] upline remaining is required.",
  slots_account_min_required: "[Slots] account minimum is required.",

  livecasino_upline_pt_required: "[Livecasino] upline PT is required.",
  livecasino_account_pt_required: "[Livecasino] account PT is required.",
  livecasino_upline_remaining_required: "[Livecasino] upline remaining is required.",
  livecasino_account_min_required: "[Livecasino] account minimum is required.",

  invalid_hdp_upline_pt: "Invalid HDP upline PT.",
  invalid_hdp_account_pt: "Invalid HDP account PT.",
  invalid_hdp_upline_remaining: "Invalid HDP upline remaining.",
  invalid_hdp_account_min: "Invalid HDP account minimum.",

  invalid_oxt_upline_pt: "Invalid 1x2 upline PT.",
  invalid_oxt_account_pt: "Invalid 1x2 account PT.",
  invalid_oxt_upline_remaining: "Invalid 1x2 upline remaining.",
  invalid_oxt_account_min: "Invalid 1x2 account minimum.",

  invalid_others_upline_pt: "Invalid others upline PT.",
  invalid_others_account_pt: "Invalid others account PT.",
  invalid_others_upline_remaining: "Invalid others upline remaining.",
  invalid_others_account_min: "Invalid others account minimum.",

  invalid_parlay_upline_pt: "Invalid parlay upline PT.",
  invalid_parlay_account_pt: "Invalid parlay account PT.",
  invalid_parlay_upline_remaining: "Invalid parlay upline remaining.",
  invalid_parlay_account_min: "Invalid parlay account minimum.",

  invalid_slots_upline_pt: "Invalid [slots] upline PT.",
  invalid_slots_account_pt: "Invalid [slots] account PT.",
  invalid_slots_upline_remaining: "Invalid [slots] upline remaining.",
  invalid_slots_account_min: "Invalid [slots] account minimum.",

  invalid_livecasino_upline_pt: "Invalid [livecasino] upline PT.",
  invalid_livecasino_account_pt: "Invalid [livecasino] account PT.",
  invalid_livecasino_upline_remaining: "Invalid [livecasino] upline remaining.",
  invalid_livecasino_account_min: "Invalid [livecasino] account minimum.",

  comm_hdp_a_required: "Commission HDP A is required.",
  comm_hdp_b_required: "Commission HDP B is required.",
  comm_hdp_c_required: "Commission HDP C is required.",
  comm_hdp_d_required: "Commission HDP D is required.",
  comm_hdp_e_required: "Commission HDP E is required.",
  comm_hdp_f_required: "Commission HDP F is required.",
  comm_hdp_g_required: "Commission HDP G is required.",
  comm_hdp_h_required: "Commission HDP H is required.",
  comm_hdp_i_required: "Commission HDP I is required.",
  comm_hdp_j_required: "Commission HDP J is required.",
  comm_1x2_required: "Commission 1X2 is required.",
  comm_others_required: "Commission Others is required.",
  comm_slots_required: "Commission Slots is required.",
  comm_casino_required: "Commission Live Casino is required.",
  hdp_mmo_upline_pt_required: "HDP MMO Upline PT setting is required.",
  hdp_mmo_account_pt_required: "HDP MMO account PT setting is required.",
  hdp_mmo_upline_remaining_required: "HDP MMO Upline remaining PT setting is required.",
  hdp_mmo_account_min_required: "HDP MMO account min setting is required.",
  parlay_mmo_upline_pt_required: "Parlay MMO Upline PT setting is required.",
  parlay_mmo_account_pt_required: "Parlay MMO Account PT setting is required.",
  parlay_mmo_upline_remaining_required: "Parlay MMO Upline remaining PT setting is required.",
  parlay_mmo_account_min_required: "Parlay MMO Account minimum PT setting is required.",
  comm_hdp_mmo_required: "Commission HDP MMO is required.",
  comm_parlay_mmo_a_required: "Commission parlay MMO A is required.",
  comm_parlay_mmo_b_required: "Commission parlay MMO B is required.",
  invalid_comm_hdp_mmo: "Invalid commission HDP MMO.",
  invalid_comm_parlay_mmo_a_required: "Invalid commission parlay MMO A.",
  invalid_comm_parlay_mmo_b_required: "Invalid commission parlay MMO B.",
  invalid_login_source: "Invalid login source.",
  invalid_comm_hdp_a: "Invalid commission HDP A.",
  invalid_comm_hdp_b: "Invalid commission HDP B.",
  invalid_comm_hdp_c: "Invalid commission HDP C.",
  invalid_comm_hdp_d: "Invalid commission HDP D.",
  invalid_comm_hdp_e: "Invalid commission HDP E.",
  invalid_comm_hdp_f: "Invalid commission HDP F.",
  invalid_comm_hdp_g: "Invalid commission HDP G.",
  invalid_comm_hdp_h: "Invalid commission HDP H.",
  invalid_comm_hdp_i: "Invalid commission HDP I.",
  invalid_comm_hdp_j: "Invalid commission HDP J.",
  invalid_comm_1x2: "Invalid commission 1X2.",
  invalid_comm_others: "Invalid commission Others.",
  invalid_comm_slots: "Invalid commission slots",
  invalid_comm_livecasino: "Invalid commission livecasino",
  invalid_bet_limit_packages: "Invalid bet limit packages.",
  invalid_credit_limit: "Invalid credit limit.",
  invalid_member_credit_limit: "Invalid member credit limit.",
  invalid_win_limit_multiplier: "Invalid win limit.",
  invalid_downline_limit: "Invalid downline limit.",
  downline_limit_required: "Downline limit is required.",
  system_type_required: "System type is required.",
  invalid_system_type: "Invalid system type.",
  invalid_agent_id: "Invalid agent ID.",
  db_exception: "Database exception.",

  update_bank_account_confirm: "Are you sure want to update bank account?",
  update_bank_account_cancel: "Update bank account failed.",
  update_bank_account_success: "Bank account successfully updated!",
  update_social_account_confirm: "Are you sure want to update social account?",
  update_social_account_cancel: "Update social account failed.",
  update_social_account_success: "Social account successfully updated!",

};
